import {
  SEND_SOS_SIGNAL,
  SAVE_NEW_TIMER_COUNT_VALUE,
  CHECK_PASSWORD_ERROR,
  SAVE_SOS_COORDS,
  CHECK_PASSWORD,
  SEND_SIGNAL_ABORT,
  START_SOS_SIGNAL_TIMER,
  SOS_SIGNAL_SUCCESS,
  GET_ACTIVE_SIGNALS,
  GET_ACTIVE_SIGNALS_SUCCESS,
  SOS_ACTION_FORBIDDEN,
  CLEAR_SOS_ACTION_FORBIDDEN,
} from '../constants/ActionTypes';

export function sendSosSignal() {
  return { type: SEND_SOS_SIGNAL };
}

export function startSosSignalTimer() {
  return { type: START_SOS_SIGNAL_TIMER };
}

export function sosSignalSuccess() {
  return { type: SOS_SIGNAL_SUCCESS };
}

export function saveCoordinates(coords) {
  return { type: SAVE_SOS_COORDS, payload: coords };
}

export function saveNewTimerValue(timer) {
  return { type: SAVE_NEW_TIMER_COUNT_VALUE, payload: timer };
}

export function sendSignalAbort() {
  return { type: SEND_SIGNAL_ABORT };
}

export function checkPassword(password) {
  return { type: CHECK_PASSWORD, payload: password };
}

export function checkPasswordError(isPasswordCorrect) {
  return { type: CHECK_PASSWORD_ERROR, payload: isPasswordCorrect };
}

export function getActiveSignals() {
  return { type: GET_ACTIVE_SIGNALS };
}

export function getActiveSignalsSuccess(hasActiveAlarm) {
  return { type: GET_ACTIVE_SIGNALS_SUCCESS, payload: { hasActiveAlarm } };
}

export function sosActionForbidden(message) {
  return { type: SOS_ACTION_FORBIDDEN, payload: { message } };
}

export function clearSosActionForbidden() {
  return { type: CLEAR_SOS_ACTION_FORBIDDEN };
}
